import request from '@/router/axios'

export function fetchPlaceList(query) {
	return request({
		url: '/dist/distChannel/page',
		method: 'get',
		params: query,
	})
}

//获取渠道不分页
export function getObjList() {
	return request({
		url: '/dist/distChannel/list',
		method: 'get',
	})
}

//获取主渠道不分页
export function getObjListMain(query = {parentId: 0}) {
	return request({
		url: '/dist/distChannel/list',
		method: 'get',
		params: query,
	})
}

//获取留资线索
export function queryCus(query = {}) {
	return request({
		url: '/dist/distChannel/searchCrmCustomer',
		method: 'get',
		params: query,
	})
}
//获取渠道关联的客户列表
export function getCustomerList(query = {}) {
	return request({
		url: '/dist/distChannel/customer',
		method: 'get',
		params: query,
	})
}

export function addObj(obj) {
	return request({
		url: '/dist/distChannel',
		method: 'post',
		data: obj,
	})
}

export function getObj(id) {
	return request({
		url: '/dist/distChannel/' + id,
		method: 'get',
	})
}

export function getInvisibleObj() {
	return request({
		url: '/dist/distProduct/invisibleInsureTypes',
		method: 'get',
	})
}

export function delObj(id) {
	return request({
		url: '/dist/distChannel/' + id,
		method: 'delete',
	})
}

export function putObj(obj) {
	return request({
		url: '/dist/distChannel',
		method: 'put',
		data: obj,
	})
}

export function getPutObj(method, obj) {
	return request({
		url: '/dist/distChannel',
		method,
		data: obj,
	})
}

export function fetchTree(query) {
	return request({
		url: '/dist/distChannel/tree',
		method: 'get',
		params: query,
	})
}

//首次获课时间
export function getFirstHuokeTime(wechatId) {
	return request({
		url: '/dist/distChannel/queryAcquireTime',
		params: {
			wechatId,
		},
	})
}

//业务跟进人
export function getBusinessFollower(query) {
	return request({
		url: '/dist/contact/sort/page',
		method: 'get',
		params: query,
	})
}

export function addBusinessFollower(obj) {
	return request({
		url: '/dist/contact/sort',
		method: 'post',
		data: obj,
	})
}

export function editBusinessFollower(obj) {
	return request({
		url: '/dist/contact/sort',
		method: 'put',
		data: obj,
	})
}

export function editFollowSort(obj) {
	return request({
		url: '/dist/distChannel/editFollowSort',
		method: 'put',
		data: obj,
	})
}

export function delBusinessFollower(id) {
	return request({
		url: '/dist/contact/sort/' + id,
		method: 'delete',
	})
}

export function searchCrmCustomer(query) {
	return request({
		url: '/dist/distChannel/searchCrmCustomer',
		method: 'get',
		params: query,
	})
}
export function getRiskTag(query) {
	return request({
		url: '/admin/tag/listByScene',
		method: 'get',
		params: query,
	})
}

export function searchCustomerClue(query) {
	return request({
		url: '/dist/distChannel/searchCustomerClue',
		method: 'post',
		data: query,
	})
}
export function customerSourceDic(query) {
	return request({
		url: '/dist/distChannel/customerSource',
		method: 'get',
		params: query,
	})
}

//获取渠道名称 根据名称
export function distChannelByName(query = {}) {
	return request({
		url: '/dist/distChannel/getTreeByName',
		method: 'get',
		params: query,
	})
}

export function awardImport(obj) {
	return request({
		url: '/dist/settle/award/import',
		method: 'post',
		data: obj,
	})
}
//产品 kuid 导入批量更新
export function productIdsImport(obj) {
	return request({
		url: '/dist/distProduct/batch/switch/products',
		method: 'post',
		data: obj,
	})
}

//批量更新业务跟进人导入
export function batchUpdateFollowImport(obj) {
	return request({
		url: '/dist/distChannel/export/follow',
		method: 'post',
		data: obj,
	})
}

//判断 手机号登录名是否已经存在
export function distAccountExist(query = {}) {
	return request({
		url: '/dist/distAccount/exist',
		method: 'get',
		params: query,
	})
}

// 根据ids查询企微沟通群
export function searchWeworkGroup(query = {}) {
	return request({
		url: '/dist/distChannel/searchWeworkGroup',
		method: 'get',
		params: query,
	})
}
